import { AccessibleIcon } from '@radix-ui/react-accessible-icon'
import React, { SVGProps } from 'react'

interface TrashCan extends SVGProps<SVGSVGElement> {
  label?: string
}

const TrashCan: React.FC<TrashCan> = ({ label = 'trashCan', ...restProps }) => {
  return (
    <AccessibleIcon label={label}>
      <svg
        {...restProps}
        data-testid="trash-can-svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 3C10.8954 3 10 3.89543 10 5H4L3.88338 5.00673C3.38604 5.06449 3 5.48716 3 6C3 6.55228 3.44772 7 4 7H20L20.1166 6.99327C20.614 6.93551 21 6.51284 21 6C21 5.44772 20.5523 5 20 5H14C14 3.89543 13.1046 3 12 3Z"
          fill="currentColor"
        />
        <path
          d="M17.9719 8.0003L18.0887 8.00394C18.5995 8.0494 18.9863 8.47139 18.9997 8.97189L18.9961 9.08865L18.2493 17.4562C18.0331 18.8611 16.864 19.913 15.4607 19.9949L15.2842 20H8.71584C7.29435 20 6.07697 19.0044 5.77585 17.5738L5.74303 17.3928L5.00394 9.08865C4.95498 8.53854 5.36124 8.0529 5.91135 8.00394C6.42216 7.95847 6.87739 8.30552 6.97902 8.79578L6.99606 8.91135L7.72747 17.1521C7.79674 17.6024 8.15973 17.9438 8.60337 17.9937L8.71584 18H15.2842C15.7366 18 16.127 17.6974 16.2408 17.3201L16.2648 17.2155L17.0039 8.91135C17.0459 8.43982 17.4087 8.07399 17.8579 8.00992L17.9719 8.0003Z"
          fill="currentColor"
        />
      </svg>
    </AccessibleIcon>
  )
}

export default TrashCan
